
// const BASE_URL=
// process.env.NODE_ENV === "development"
// ?"http://localhost:3000"
// :"https://twodbsin1bkend.onrender.com"

const BASE_URL =
process.env.NODE_ENV === "development"
?"https://myappsbackend.link"
:"https://myappsbackend.link"

export default BASE_URL

//https://doc-appointment-booking-app.onrender.com
//https://cnc-and-docapp-webservice.onrender.com
